import { CSSProperties, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Icon } from "@sellar-io/components";

export const Expandable = ({
  children,
  className,
  style,
  expanded,
  onArrowClick,
  onClick,
  arrowColor = "var(--theme-action-color)",
  arrowSize = 0.9,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  expanded?: boolean;
  onArrowClick?: () => void;
  onClick?: () => void;
  arrowColor?: string;
  arrowSize?: number;
}) => {
  return (
    <div
      className={twMerge(
        "relative grid grid-cols-[1fr_min-content] gap-1 overflow-hidden",
        expanded && "max-h-[1000px] overflow-y-auto",
        className,
      )}
      onClick={onClick}
      style={style}
    >
      {children}
      <div onClick={onArrowClick}>
        <Icon
          size={arrowSize}
          className={twMerge(
            "h-[12px] cursor-pointer transition-transform duration-200 ease-in-out",
            expanded ? "-rotate-90" : "rotate-90",
          )}
          color={arrowColor}
          icon={"CHEVRON_RIGHT"}
        />
      </div>
    </div>
  );
};
